import { mergeAttributes, Node, NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';

import { Callout } from '@/components/core/Callout';
import { useTranslation } from '@/hooks/useTranslation';

const CustomNodeViewWrapper = (props:any) => {

    const { t } = useTranslation();
    const isEditable = props.editor.isEditable;

    return (
        <NodeViewWrapper>
            {isEditable && <Callout className='tw-flex tw-items-center'>
                <p className="tw-m-0">{t('ENHANCED_CONTENT.DROP_BLOCKS_BELOW')}</p>
            </Callout>}
        </NodeViewWrapper>
    );
};

const EdgeNode = Node.create({
    name: 'edge_node',
    group: 'edge_node',
    defining: true,
    draggable: false,
    atom: true,

    parseHTML() {
        return [{
            tag: 'div',
        }];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'div',
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)
        ];
    },

    addNodeView() {
        return ReactNodeViewRenderer(CustomNodeViewWrapper);
    }
});

export default EdgeNode;
